var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.356 1.5061H22.5928V22.593H0V1.5061H4.23584V0H5.64697V1.5061H16.9468V0H18.3579L18.356 1.5061ZM4.23584 3.01196H1.41211V6.0249H21.1821V3.01196H18.3569V4.51807H16.9458V3.01196H5.646V4.51807H4.23486L4.23584 3.01196ZM1.41211 21.0869H21.1821V7.53003H1.41211V21.0869ZM4.23584 13.5559V12.05H5.64697V13.5559H4.23584ZM4.23584 16.5681V15.062H5.64697V16.5681H4.23584ZM4.23584 19.5811V18.075H5.64697V19.5811H4.23584ZM8.47314 10.543V9.03711H9.88281V10.543H8.47314ZM8.47314 13.5559V12.05H9.88281V13.5559H8.47314ZM8.47314 16.5681V15.062H9.88281V16.5681H8.47314ZM8.47314 19.5811V18.075H9.88281V19.5811H8.47314ZM12.708 10.543V9.03711H14.1201V10.543H12.708ZM12.708 13.5559V12.05H14.1201V13.5559H12.708ZM12.708 16.5681V15.062H14.1201V16.5681H12.708ZM12.708 19.5811V18.075H14.1201V19.5811H12.708ZM16.9438 10.543V9.03711H18.355V10.543H16.9438ZM16.9438 13.5559V12.05H18.355V13.5559H16.9438ZM16.9438 16.5681V15.062H18.355V16.5681H16.9438Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.49387d69.svg";
export { ForwardRef as ReactComponent };